<template>
  <IndicatorWrapper class="commercial-pulse" :status="status" v-if="visible" :isMain="true" :currentFilters="currentFilters">
    <div class="top">
      <div class="bkg"/>
      <TextWithFilters
        ref="textComponent"
        textKey="recovery_text_with_filters"
        :textData="dynamicTextData"
        v-model="internalCurrentFilters"
      ></TextWithFilters>
    </div>
    <div class="bottom">
      <MultiValueBar :data="chartData" v-model="internalCurrentFilters.group_recovery" :status="status" :compareData="compareData"></MultiValueBar>
      <ChartLegend :items="legendItems" v-show="isCompareMode" type="line"></ChartLegend>
      <ChartDescription :values="internalCurrentFilters" :indicator="indicator" descriptionKey="recovery_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
// import ValueBar from '@/components/IndicatorCards/parts/charts/ValueBar'
import MultiValueBar from '@/components/IndicatorCards/parts/charts/MultiValueBar'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
import data from '@/assets/fake_data/generics/recovery_NEW.json'

export default {
  name: 'Recovery',

  mixins: [indData, indDynamicText],
  components: {
    TextWithFilters,
    // ValueBar,
    MultiValueBar,
    ChartDescription,
    IndicatorWrapper,
    ChartLegend
  },
  data () {
    return {
      internalCurrentFilters: {group_recovery:'commerce-sector-total'}
    }
  },
  watch: {
    internalCurrentFilters(){
      let clone = {...this.internalCurrentFilters}
      delete clone.group_recovery
      if(Object.keys(clone).length) this.currentFilters = clone
    }
  },
  // props: ['indicatorData'],
  computed:{
    indicatorData() {
      return {
        main_value: {
          required: true,
          triggers_jump: true,
          get () {
            return Api.getIndicatorData('ind_trust',this.currentFilters)
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('ind_trust',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    }, 
    dynamicTextData (){
      return [
        {
          type: 'select',
          id: 'timeScale',
        },
        {
          type: 'select',
          id: 'group_recovery',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: this.barValue && this.barValue.value,
          unit: '%'
        }
      ]
    },
    sectorsData () {
      // FAKE, debe ser "el if" pero los datos de alvaro son "demasiado malos" para probar...
      // return data.data
      if(this.indicatorData.main_value && this.indicatorData.main_value.data) return this.indicatorData.main_value.data
      else return []
    },
    chartData () {
      return this.sectorsData
    },
    compareData () {
      if(this.indicatorData.compare_data && this.indicatorData.compare_data.data) return this.indicatorData.compare_data.data
      else return null
    },
    barValue () {
      return this.sectorsData.find((d)=>d.id === this.internalCurrentFilters.group_recovery)
    },
    
  }
}
</script>

<style lang="stylus" scoped>
.commercial-pulse
  .top
    position relative
    .bkg
      background-image url('~@/assets/images/TPV.png')
      position: absolute;
      background-repeat: no-repeat;
      width 'calc(100% + %s)' % vw(10px)
      height 100%
      top: 0px;
      left: 0px;
      pointer-events none
      z-index 0
      .mobile &
        height: 200%;
        background-size: 55%;
        background-position: 145% 5%;
      .desktop &
        background-size: 60%;
        background-position: 110% 66%;
    .text-with-filters
      position: relative;
      >>> .rendered-text
        width 80%
  .desktop &

    .multi-value-bar
      margin vh(20px) vw(10px) 0 vw(5px)
      flex 0 0 vh(180px)
  .mobile &
    .multi-value-bar
      margin vh(20px) vw(10px) 0 vw(5px)
      flex 0 0 vh(180px)
</style>